const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MONTHS_LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const parseIso = (iso) => { const [y, m, d] = iso.split('-').map(Number); return new Date(y, m - 1, d); };
export const toIso = (dt) => `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
export const longDate = (iso) => { const d = parseIso(iso); return `${DAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`; };
export const shortDate = (iso) => { const d = parseIso(iso); return `${MONTHS[d.getMonth()]} ${d.getDate()}`; };
export const weekdayNarrow = (iso) => DAYS[parseIso(iso).getDay()][0];
export const monthYear = (iso) => { const d = parseIso(iso); return `${MONTHS_LONG[d.getMonth()]} ${d.getFullYear()}`; };
export const fmtMinutes = (min) => {
  if (min == null) return null;
  if (min < 60) return { value: Math.round(min), unit: 'min' };
  if (min < 1440) return { value: Math.round((min / 60) * 10) / 10, unit: 'hrs' };
  return { value: Math.round((min / 1440) * 10) / 10, unit: 'days' };
};
